// extracted by mini-css-extract-plugin
export default {"gallery":"gallery_gallery__PAdA0","egplayaelement0a":"gallery_egplayaelement0a__yrb3w","titleLink":"gallery_titleLink__JJoTc","arrow":"gallery_arrow__0wQ1u"};